import React ,{useState}from 'react'

import FileGambar from './FileGambar';
import FileLink from './FileLink';
import FilePdf from './FilePdf';
import FileVideo from './FileVideo';
import SmartText from '../SmartText';
import ChevronGreen from 'assets/icon/chevron-green.png'
import ChevronGrey from 'assets/icon/chevron-grey.png'
import KomentExpert from 'assets/icon/koment-expert.png'
import CommentBlue from 'assets/icon/comment-blue.png'
import CommentGrey from 'assets/icon/comment-grey.png'
import EyeGrey from 'assets/icon/eye-grey.png'
import FlagGrey from 'assets/icon/flag-grey.png'
import FlagRed from 'assets/icon/flag-red.png'
import DefaultAva from 'assets/icon/default-ava.jpeg'

import LikeGreen from 'assets/icon/like-green.png'
import LikeGrey from 'assets/icon/like-grey.png'
import Kebab from 'assets/icon/Kebab.png'
import { Button } from '@material-ui/core';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import Cookie from 'universal-cookie'
import CommentOnCard from './CommentOnCard';
import { Collapse } from '@material-ui/core';
const cookie=new Cookie()
const profile=cookie.get('profile_cookie_forum')
const HtmlTooltip = withStyles((theme) => ({
    tooltip: {
      padding:8,
      backgroundColor: 'black',
      color: 'white',
      fontSize: theme.typography.pxToRem(12),
      border: 'black',
      boxShadow: 'black',
    },
    arrow: {
        "&:before": {
          border: '1px solid black',
          backgroundColor: "black",
        },
      },
  }))(Tooltip);
export default function Card(props) {
    let {
        data,
        onClickVote,
        index,
        onClickFlag,
        forum_auth,
        optionToggle,
        option,
        editDiskusi,
        deleteDiskusi,
        opencomment,
        openCommentToggle,
    }=props
    function get_url_extension( url ) {
        return url.split(/[#?]/)[0].split('.').pop().trim();
    }
    function linkify(text) {
        var urlRegex = /(((https?:\/\/)|(www\.))[^\s]+)/g;
        return text.match(urlRegex)
    }
    let extension=get_url_extension(data.attachment)
    const renderPreviewFile=()=>{
        if(extension==='jpg'||extension==='jpeg'||extension==='png'){
            return <div className="card-file"><FileGambar url={data.attachment}/></div>
        }
        if(extension==='pdf'){
            return <div className="card-file"><FilePdf url={data.attachment}/></div>
        }
        if(extension==='mp4'){
            return <div className="card-file"><FileVideo url={data.attachment}/></div>
        }
        if(linkify(data.text)!==null){
            return <div className='card-file'><FileLink url={linkify(data.text)[0]} /></div>
        }
    }
    const renderVoteImg=(data)=>{

        if(data.nvote>0){
            return LikeGreen

        }else{
            return LikeGrey

        }
    }
    const renderCommentImg=(data)=>{
        if(data.nMark>0){
            return KomentExpert
            // if(data.nMark>0){
            //     return KomentExpert
            // }else{
            //     return CommentBlue
            // }
        }else if(data.isExpert){
            return CommentBlue
        }else{
            return CommentGrey
        }
        
    }
    const renderEyeImg=(data)=>{
        return EyeGrey
    }
    const renderFlagImg=(data)=>{
        if(data.nflag>0){
            return FlagRed
        }else{
            return FlagGrey
        }
    }
    const convertHash=(tag)=>{
        let conv=tag.replace('#','%23')
        return conv
    }
    
    function urlify(text) {
        var urlRegex = /(https?:\/\/[^\s]+)/g;
        return text.replace(urlRegex, function(url) {
          return '<a href="' + url + '">' + url + '</a>';
        })
    }
    const handleDisabled=()=>{
        if(data.author.userId===profile.id){
            if(data.ncomment>0){
                return false
            }else{
                return true
            }
        }else{
            return false
        }
    }
    function renderOptionCard(){
        return(
            <div>
                {handleDisabled()&&
                    <>
                        <Button onClick={()=>editDiskusi(data,index)} className='btn-remove-capital' variant="text" color="primary" size="small">Ubah</Button>
                        <div style={{width:'100%',height:0.5,backgroundColor:'#aaaaaa'}}></div>
                    </>
                }
                {(handleDisabled()||forum_auth.isAdministrator)&&
                    <>
                        <Button onClick={()=>deleteDiskusi(data,index)}  className='btn-remove-capital' variant="text" color="secondary" size="small">Hapus</Button>
                        <div style={{width:'100%',height:0.5,backgroundColor:'#aaaaaa'}}></div>
                    </>
                }
                {forum_auth.canFlag&&
                    <>
                        <Button onClick={()=>onClickFlag(data,index)}  className='btn-remove-capital' variant="text" color="primary" size="small">Laporkan</Button>
                    </>
                }
            </div>

        )
    }
    return (
        <div>
            <div className='card-wrapper'>
                {option[index]&&<div onClick={()=>optionToggle(data,index)} className='option-backdoor'></div>}

                <div className='card-header'>
                    <div className='header-profile div-flex div-align-center'>
                        <img src={data.author.profilePic!==""?data.author.profilePic:DefaultAva} className='ava-circle'/>
                        &nbsp;&nbsp;
                        <div>
                            <div className='header-author '>
                                <p className='font-nuno margin-0'>Dibuat oleh <b>{data.author.name}</b></p>

                            </div>
                            <div className='header-timestamp'>
                                <p className='font-nuno margin-0'>{data.lastActivity}</p>

                            </div>
                        </div>
                    </div>
                    <div className='card-option'>
                        <img onClick={()=>optionToggle(data,index)} src={Kebab}/>
                        {option[index]&&<div className='option-container'>
                            {renderOptionCard()}
                        </div>}
                    </div>
                </div>
                <div className='card-content'>
                    <a href={`/detail/${data.slug}`}><h4 className='font-nunito card-title cursor-pointer'>{data.title}</h4></a>
                    <SmartText text={urlify(data.text)}/>
                </div>
                
                {renderPreviewFile()}
                <div className='card-footer'>
                    <div className='hashtag-section'>
                        {data.tags.map((data,i)=>(
                            <a key={i} href={`/search?q=${convertHash(data)}`}><p  className='hashtag-item hashtag-card font-nunito'>{data}</p></a>
                        ))}
                    </div>
                    <div className='card-action'>
                        {/* {forum_auth.canVote&& */}
                            <HtmlTooltip title="Suka" placement="bottom" arrow>
                                <div className='footer-action'>
                                    <p className='font-nunito margin-0 footer-text-action' >{data.nvote}</p>
                                    <img onClick={()=>onClickVote(data,index)} src={renderVoteImg(data)} />
                                    <p className='font-nunito margin-0 '>Sukai</p>

                                </div>
                            </HtmlTooltip>
                        {/* } */}
                        <HtmlTooltip title={`${data.ncomment===0?'Belum ada tanggapan':data.nMark===0?`${data.ncomment} komentar`:`${data.ncomment} Komentar dengan ${data.nMark} Komentar solutif`}`} placement="bottom" arrow>
                            <div className='footer-action' onClick={()=>openCommentToggle(data,index)}>
                                <p className='font-nunito margin-0 footer-text-action' >{data.ncomment}</p>
                                <img src={renderCommentImg(data)} />
                                <p className='font-nunito margin-0 '>Komentari</p>

                            </div>
                        </HtmlTooltip>
                        <HtmlTooltip title={`${data.nview===0?'Belum ada yang melihat lengkap diskusi ini':`${data.nview} orang telah melihat`}`} placement="bottom" arrow>
                            <div className='footer-action'>
                                <img src={renderEyeImg(data)}/>
                                <p className='font-nunito margin-0 '>{data.nview!==0&&data.nview}</p>
                            </div>
                        </HtmlTooltip>
                        {data.nflag>0&&<div className='footer-action'>
                            <img onClick={()=>onClickFlag(data,index)} src={renderFlagImg(data)}/>
                        </div>}
                    </div>
                </div>
                {/* <Collapse in={opencomment[index]}> */}
                    {opencomment[index]&&
                        <CommentOnCard data={data}/>
                    }
                {/* </Collapse> */}
                
            </div>
        </div>
    )
}
